export default "__VITE_ASSET__BCEdU$9v__"